import { BreadcrumbsItem } from 'wix-style-react';
import { IPage, PageRoute, Pages } from '@src/types';
import { TranslationFunction } from 'i18next';

export const getPageFromPath = (path: string): IPage => Pages[path as PageRoute];
export const pagesContainsPath = (path: string): boolean => !!Pages[path as PageRoute];

const getStartPath = (paths: string[]) => (paths.length > 1 ? paths[paths.length - 1] + '/' : '/');
export const createBreadcrumbsFromPath = (pathname: string): BreadcrumbsItem[] => {
  const pagesArray: IPage[] = pathname
    .split('/')
    .filter((path) => path)
    .reduce((paths, path) => [...paths, getStartPath(paths) + path], ['/'])
    .filter((path) => pagesContainsPath(path))
    .map((path) => getPageFromPath(path));

  if (pagesArray.length <= 1) {
    return [];
  }

  return pagesArray.map((page: IPage, index: number) => ({
    id: page.route,
    value: page.titleKey,
    disabled: index === pagesArray.length - 1,
  }));
};

export interface TranslateBreadcrumbsOptions {
  t: TranslationFunction;
  breadcrumbItems: BreadcrumbsItem[];
}

export const translateBreadcrumbs = ({ t, breadcrumbItems }: TranslateBreadcrumbsOptions): BreadcrumbsItem[] => {
  return breadcrumbItems.map((breadcrumbItem: BreadcrumbsItem) => ({
    ...breadcrumbItem,
    value: t(breadcrumbItem.value?.toString() || ''),
  }));
};
